import moment from 'moment';

import {
  PaymentRounded as PaymentMethodIcon,
  LocalShippingRounded as LocalShippingIcon,
  EventRounded as EventIcon,
  ScheduleRounded as ScheduleIcon,
} from '@material-ui/icons';

import PaymentStatusChip from '../../components/Admin/Order/Chip/PaymentStatusChip';
import AdvStatusChip from '../../components/Admin/Order/Chip/AdvStatusChip';
import { formatPrice } from '../../shared/utils/format-price.util';
import { formatShortDate } from '../../shared/utils/format-date.util';
import type { Order } from '../types/order.type';
import type { OrderTableRow } from '../components/Tables/OrderTableWithDetails.component';
import { ADMIN_ORDER_V2_APP_PATHS } from '../constants/orders-app-paths.constant';

export function mapOrderToTableRow(order: Order): OrderTableRow {
  const isPaid = order.status === 'paid' || order.status === 'partial';
  const paymentMethod = isPaid ? (order.status === 'paid' ? 'Carte bancaire' : 'Edenred') : 'Non payée';

  return {
    id: order.id,
    href: ADMIN_ORDER_V2_APP_PATHS.ORDER_DETAILS(order.id),
    cells: [
      { key: 'owner', content: `${order.owner.lastName} ${order.owner.firstName}` },
      { key: 'status', content: <PaymentStatusChip status={order.status} /> },
      { key: 'advStatus', content: <AdvStatusChip advStatus={order.advStatus} /> },
      { key: 'totalHt', content: formatPrice(order.totals.totalHt) },
      { key: 'totalTtc', content: formatPrice(order.totals.totalTtc) },
      { key: 'deliveryDay', content: formatShortDate(order.deliveryInfos.deliveryDate) },
      { key: 'created', content: moment(order.createdAt).format('DD MMMM YYYY à HH:mm') },
    ],
    details: {
      headerSummary: [
        {
          key: 'payment',
          label: 'Méthode de paiement',
          value: paymentMethod,
          Icon: <PaymentMethodIcon />,
        },
        {
          key: 'deliveryType',
          label: 'Type de livraison',
          value: order.deliveryInfos.deliveryType,
          Icon: <LocalShippingIcon />,
        },
        {
          key: 'deliveryDate',
          label: 'Date de livraison',
          value: moment(order.deliveryInfos.deliveryDate).format('dddd DD MMMM YYYY'),
          Icon: <EventIcon />,
        },
        {
          key: 'deliverySchedule',
          label: 'Horaire de livraison',
          value: order.deliveryInfos.deliverySchedule,
          Icon: <ScheduleIcon />,
        },
      ],
      items: order.items.map((item) => ({
        id: item.productId ?? item.name,
        name: item.name,
        category: item.category,
        subcategory: item.subcategory,
        noLabel: item.noLabel,
        quantity: item.quantity,
        unitPrice: item.price,
      })),
      deliveryCost: order.deliveryCost,
    },
  };
}
